import { render, staticRenderFns } from "./SumContent.vue?vue&type=template&id=3b4bc452&"
import script from "./SumContent.vue?vue&type=script&lang=js&"
export * from "./SumContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports